module.exports = __webpack_public_path__ + "img/bg.85eb0cc4.png";